module.exports = __webpack_public_path__ + "img/quick_set.0636734b.svg";